import { red, blueGrey, grey } from "@mui/material/colors";

const purple = "#333D7A";
const light = "#7D25EC";
const dark = "#1B2559";
const white = "#ffffff";
const black = "#000000";
const gray = "#8E8E8E";
const lightGray = "#D8D8D8";
const mediumGray = "#DCDCDC";
const ghostWhite = "#F4F5F9";
const indigo = "#8333F4";
const blueMagenta = "#440898";
const whiteSmoke = "#FAFAFC";
const lavender = "#F3EBFE";
const silver = "#8B899F";
const textPrimary = "#4A4A4A"; // Light grey for primary text
const textSecondary = "#6B6B6B"; // Slightly darker grey for secondary text
const textDanger = '#f40202'
const textSuccess = '#27ae60'
const successBackground = '#d3f6e3'
const textDisable = '#8E8E8E'
const textDisableBackground = '#f5f5f5'
// The blue "Submitted" state — the one hue in the app that isn't purple,
// green, amber or red. Declared here rather than typed inline so the pair
// (foreground/background) stays a pair.
const infoMain = '#1565c0'
const infoLight = '#e3f2fd'

export const palette = {
  primary: {
    main: indigo,
    light: light,
    dark: dark,
    black: black,
    white: white,
    gray: gray,
    lightGray: lightGray,
    blueMagenta: blueMagenta,
    whiteSmoke: whiteSmoke,
    lavender: lavender,
    silver: silver
  },
  secondary: {
    main: white,
    gray: "#E7E8EC",
    mediumGray: mediumGray,
  },
  text: {
    primary: textPrimary, // Dynamic light grey for primary text
    secondary: textSecondary, // Dynamic slightly darker grey for secondary text
    textDanger: textDanger,
    textSuccess: textSuccess,
    textDisable: textDisable
  },
  error: {
    contrastText: white,
    dark: red[900],
    main: red[600],
    light: red[400],
  },
  // Without this block MUI fills in its own green for `success.main`, which
  // is a different green from the one text.textSuccess already declares —
  // two greens for the same meaning. Defining it here makes the palette's
  // green the one that `success.main` resolves to everywhere.
  success: {
    main: textSuccess,
    light: successBackground,
    dark: textSuccess,
    contrastText: white,
  },
  info: {
    main: infoMain,
    light: infoLight,
    dark: infoMain,
    contrastText: white,
  },
  // Amber "info"/warning tone — the one color shared by the "In Progress"
  // status chip and the clickable "Instruction" badge (both public plan
  // page and examiner-side EnrollmentDetailPage). Centralized here instead
  // of each place typing its own hex so there's one place to retune it.
  warning: {
    main: "#c77700",
    light: "#f0c26b",
    dark: "#a35f00",
    contrastText: white,
  },
  
  link: purple,
  icon: blueGrey[600],

  background: {
    default: ghostWhite,
    paper: white,
    success: successBackground,
    textDisableBackground: textDisableBackground
  },
  divider: grey[200],
};
